import React, { Component } from "react";
import "../allUser/style/style1.css";
import { users } from "../Users";
import { getreports } from "../services/reportServices";
import ReactLoading from "react-loading";
import { getUsers } from "../services/userServices";
import Layout from "./components/Layout";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: false,
      showUsersNo: 10,
      data: [],
      users: [],
      items: [],
      events: [],
      DataisLoaded: false,
    };
    this.updateInput = this.updateInput.bind(this);
  }
  componentDidMount() {
    getreports().then((json) => {
      this.setState({
        items: json,
        DataisLoaded: true,
      });
    });
    getUsers().then((json) => {
      this.setState({
        users: json,
      });
    });
  }

  updateInput(event) {
    this.setState({ link: event.target.value });
  }

  onChangeOfInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  updateSettings(id, link) {
    let new_link = "";

    Object.keys(this.state)?.map((Key) => {
      if (Key === id) {
        new_link = this.state[Key];
      }
    });

    
   
  }

  getPaginationGroup() {
    let totalPage = Math.ceil(users.length / this.state.showUsersNo);
    return totalPage;
  }

  render() {
    let pages = this.getPaginationGroup();
    let pageComp = [];
    const { DataisLoaded, items } = this.state;

    for (let index = 0; index < pages; index++) {
      pageComp.push(
        <li className="page-item">
          <a
            className="page-link"
            href="#"
            onClick={() => {
              this.pageClick(index + 1);
            }}
          >
            {index + 1}
          </a>
        </li>
      );
    }

    return (
      <>
       
        <section className="dashboard">
          <Layout>
          {!DataisLoaded && <div className="spin">
          <ReactLoading
            type={"spin"}
            color={"#000000"}
            height={"10%"}
            width={"15%"}
          />
          <div>Initializing Keycloak...</div>
        </div>}

                {DataisLoaded && <div className="main-pannel white-gradient">
                  <h3>Reports</h3>
                  <div className="col-md-12 all-user-content mt-4">
                    <div className="tab-filter">
                    
                      <div className="tab-content">
                        <div
                          className="tab-pane pt-4 active"
                          id="allteam"
                          role="tabpanel"
                        >
                          <div className="row products-row">
                            <div className="col-md-12">
                              <div className="candidates-table-sec">
                                <div className="table-header p-3 pl-4 pr-4">
                                  <div className="row">
                                    <div className="col-md-4">
                                      <p className="m-0 font-weight-600">
                                        Users
                                      </p>
                                    </div>
                                    <div className="col-md-3">
                                      <p className="m-0 font-weight-600">
                                        Requested URL
                                      </p>
                                    </div>
                                    <div className="col-md-3">
                                      <p className="m-0 font-weight-600"></p>
                                    </div>
                                    <div className="col-md-2">
                                      <p className="m-0 font-weight-600">
                                        Tool
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="table-user-data candidates-table-list bg-white">
                                  {this.state.filterData
                                    ? this.state.data?.map((item) => {
                                        return (
                                          <div
                                            key={item.id}
                                            className="row table-items m-0 align-items-center py-3"
                                          >
                                            <div className="col-md-2"></div>
                                          </div>
                                        );
                                      })
                                    : items?.map((item) => {
                                        return (
                                          <div
                                            key={item.id}
                                            className="row table-items m-0 align-items-center py-3"
                                          >
                                            <div className="col-md-4 pl-4">
                                              <div className="d-flex name align-items-center">
                                                <div className="name-img mr-3"></div>
                                                <p className="h6 gray-text m-0">
                                                  {item.user_name}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <p className="h6 gray-text m-0">
                                                {item.url}
                                              </p>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="d-flex name align-items-center">
                                                <div
                                                  className="team-img mr-3"
                                                  
                                                ></div>
                                              </div>
                                            </div>
                                            <div className="col-md-2">
                                              <p className="h6 gray-text m-0">
                                                {item.tool_name}
                                              </p>
                                            </div>
                                          </div>
                                        );
                                      })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <nav
                          aria-label="Page navigation example"
                          className="text-center mt-3 d-flex justify-content-center"
                        ></nav>
                      </div>
                    </div>
                  </div>
                </div>}
                </Layout>
        </section>
      </>
    );
  }
}
export default Settings;
